// require('./bootstrap');

import Vue from 'vue'
import App from './App.vue'
import router from './routes'
import VueRouter from 'vue-router'
import VueTheMask from 'vue-the-mask'
import Vuelidate from "vuelidate";
import keycloakvue from '@prodabel/vue-keycloak-adapter'
import Pbh from '@prodabel/piweb-lib-vue';
import store from './stores';
import permissions from './permissions.json'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import VueCryptojs from 'vue-cryptojs'
import helpers from "@/helpers";


// Import Bootstrap and BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import filter from './helpers/filter'


//Font awesome icons
import './fontawesome.js'

import requests from './requests';

Vue.prototype.$api = requests;
Vue.prototype.$hkey = '77AD039F 0E31497E E8D6E6C8 D31CAD8F 8B1C2D4F B075A0ED C22A5656 53309CCA';
Vue.prototype.$hsiv = 'BC4E0EE4 BAD23E16 6AFC6017 0A936B2B'

Vue.config.productionTip = false

Vue.use(Pbh);
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueRouter)

Vue.use(VueCryptojs)

//Vue The Mask
Vue.use(VueTheMask)

//Vuelidate
Vue.use(Vuelidate)

Vue.use(filter)

import '@/assets/css/app.css'

helpers.getVersion().then((version) => {
  Vue.prototype.$version = version;
});

//Import dos resources
Vue.use(keycloakvue, {
    store,
    router,
    authorize_disabled: false,    // o default eh false
    autorefresh_disabled: false,  // o default eh false
    sse: false,  // o default eh false,
    permissions,
    verbose: false,               // o default eh false
    // objeto de opções do método init do adapter nativo
    redirect_url_logout: window.location.protocol + "//" + window.location.host,
    options: {
      redirectUri: window.location.protocol + '//' + window.location.host + window.location.pathname +
        (window.location.search ? window.location.search : ''),
    },
    // string (ou objeto) de opções do construtor do adapter nativo
    optionsConst: window.location.protocol + '//' + window.location.host + '/keycloak.json',
});

new Vue({
  data() {
    return {
        carregando: false,
    }
  },
  render: h => h(App),
  router,
  store
}).$mount('#app')
